const RwandaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112222)">
      <path
        d="M0 19.9989C0 23.4637 0.881484 26.7227 2.4318 29.5641L20 31.3033L37.5682 29.5641C39.1185 26.7227 40 23.4637 40 19.9989L20 18.2598L0 19.9989Z"
        fill="#FFDA44"
      />
      <path
        d="M37.5682 10.4348C34.1761 4.21789 27.5809 0 20 0C12.4191 0 5.82391 4.21789 2.4318 10.4348C0.881484 13.2762 0 16.5352 0 20H40C40 16.5352 39.1185 13.2762 37.5682 10.4348Z"
        fill="#338AF3"
      />
      <path
        d="M19.9998 40.0002C27.5807 40.0002 34.1759 35.7823 37.568 29.5654H2.43164C5.82375 35.7823 12.419 40.0002 19.9998 40.0002Z"
        fill="#496E2D"
      />
      <path
        d="M22.6084 11.7059L25.0511 12.8549L23.7504 15.2205L26.4027 14.7132L26.7388 17.3925L28.5861 15.4219L30.4336 17.3925L30.7696 14.7132L33.422 15.2204L32.1214 12.8548L34.5639 11.7059L32.1213 10.5571L33.422 8.19148L30.7697 8.69883L30.4336 6.01953L28.5861 7.99016L26.7387 6.01953L26.4027 8.69883L23.7503 8.19148L25.051 10.5572L22.6084 11.7059Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112222">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default RwandaSvg;
